import React from 'react';

import MaterialInput from '@material-ui/core/Input';
import OutlinedInput from '@material-ui/core/OutlinedInput';

export const ComponentInput = ({ outlined, classes, ...props }: any) => {
  const componentClasses = {
    disabled: 'material-input--disabled',
    error: 'material-input--error',
    input: `material-input__input override ${classes ? classes.input || '' : ''}`,
    root: `material-input override ${classes ? classes.root || '' : ''}`
  };

  const outlinedInputClasses = {
    ...classes,
    ...componentClasses,
    notchedOutline: `override ${classes ? classes.notchedOutline || '' : ''}`
  };

  return outlined ? (
    <OutlinedInput {...props} classes={outlinedInputClasses} autoComplete="new-password" />
  ) : (
    <MaterialInput {...props} classes={componentClasses} autoComplete="new-password" />
  );
};
